import { CartUpdatedEvent } from '@theme/events';

// Ajout instantané depuis l'upsell « Complétez votre rituel ».
// Délégué au document pour survivre aux re-rendus du drawer.
document.addEventListener('click', async (event) => {
  const btn = event.target.closest('.cart-up__add');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const wrapper = btn.closest('.cart-up');
  const sectionId = wrapper?.dataset.sectionId;
  if (!variantId || !sectionId) return;

  btn.disabled = true;
  const original = btn.textContent;
  btn.textContent = '✓';

  try {
    const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    const addResponse = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionId,
        sections_url: window.location.pathname,
      }),
    });
    const addData = await addResponse.json();

    if (addData.status) {
      // Erreur (ex. rupture de stock) — on réinitialise le bouton.
      btn.disabled = false;
      btn.textContent = original;
      return;
    }

    // Récupère le nombre d'articles à jour pour le compteur du panier.
    let itemCount;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      itemCount = cart.item_count;
    } catch (e) {
      itemCount = undefined;
    }

    document.dispatchEvent(
      new CartUpdatedEvent(
        {},
        { source: 'cart-rituel', sections: addData.sections, itemCount },
      ),
    );
  } catch (e) {
    console.error(e);
    btn.disabled = false;
    btn.textContent = original;
  }
});
